export const isPopout = typeof window !== 'undefined' && window?.location?.pathname.startsWith('/popout/');
